__turbopack_context__.v({
  "container": "PublicFace-module__UUC_aG__container",
  "image": "PublicFace-module__UUC_aG__image",
  "imageWrapper": "PublicFace-module__UUC_aG__imageWrapper",
  "link": "PublicFace-module__UUC_aG__link",
  "name": "PublicFace-module__UUC_aG__name",
  "privateImage": "PublicFace-module__UUC_aG__privateImage",
  "sponsorLogo": "PublicFace-module__UUC_aG__sponsorLogo",
});
